import React, { Component } from 'react';

import './style.less';

class Homework extends Component {
    constructor(props){
        super(props);
        this.state = {
            sort: props.sort
        }
    }
    componentWillReceiveProps(nextPorps){
        this.setState(nextPorps);
    }

    render(){
        const { debug } = this.props;
        // const { sort } = this.state;
        return(
            <div className="container homework_new index">
                <div className="icons btn start" onClick={()=>{this.props.handleClick()}} />
                {debug === '1' &&
                    <div className="debug-btn" onClick={this.props.debugClick} >客户端调试分享</div>
                }
            </div>
        )
    }
}

export default Homework;



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/Homework.jsx